<template>
  <div>
    <div
      class="d-flex justify-content-center"
      style="padding: 5px 15px 5px 15px"
    >
      <ul class="nav nav-pills custom-tabs w-100" id="customTab" role="tablist">
        <li class="nav-item w-100" v-for="tab in displayTabs" :key="tab.key">
          <button
            class="nav-link"
            :class="['nav-link', { active: activeTab === tab.key }]"
            type="button"
            role="tab"
            @click="handleTabClick(tab.key)"
          >
            {{ tab.label }}
          </button>
        </li>
      </ul>
    </div>
    <br />
    <div class="tab-content">
      <div
        class="tab-pane fade show"
        :class="{ active: activeTab === 'equity' }"
        v-if="activeTab === 'equity'"
      >
        <EquityFundsTable />
      </div>
      <div
        class="tab-pane fade show"
        :class="{ active: activeTab === 'thematic' }"
        v-if="activeTab === 'thematic'"
      >
        <ThematicFundsTable :key="activeTab" />
      </div>
      <div
        class="tab-pane fade show"
        :class="{ active: activeTab === 'debt' }"
        v-if="activeTab === 'debt'"
      >
        <DebtFundsTable :key="activeTab" />
      </div>
      <div
        class="tab-pane fade show"
        :class="{ active: activeTab === 'hybrid' }"
        v-if="activeTab === 'hybrid'"
      >
        <HybridFundsTable :key="activeTab"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, watch } from "vue";
import EquityFundsTable from "@/components/equityFunds.vue";
import DebtFundsTable from "@/components/debtFunds.vue";
import HybridFundsTable from "@/components/hybridFunds.vue";
import ThematicFundsTable from "@/components/thematicFunds.vue";
import { useStore } from "vuex";
const store = useStore();
function handleTabClick(tabKey) {
  activeTab.value = tabKey;
}
const tabs = ref([
  { label: "Equity Funds", key: "equity" },
  { label: "Thematic funds", key: "thematic" },
  { label: "Debt Funds", key: "debt" },
  { label: "Hybrid Funds", key: "hybrid" },
]);
const isMobileView = ref(window.innerWidth <= 768);
const isMediumView = ref(window.innerWidth <= 1000);

const displayTabs = computed(() => {
  if (isMobileView.value) {
    return [
      { label: "Equity", key: "equity" },
      { label: "Thematic", key: "thematic" },
      { label: "Debt", key: "debt" },
      { label: "Hybrid", key: "hybrid" },
    ];
  } else if (isMediumView.value) {
    return [
      { label: "Equity Funds", key: "equity" },
      { label: "Thematic", key: "thematic" },
      { label: "Debt Funds", key: "debt" },
      { label: "Hybrid Funds", key: "hybrid" },
    ];
  }
  return tabs.value;
});
const activeTab = ref("equity");
const handleResize = () => {
  isMobileView.value = window.innerWidth <= 768;
  isMediumView.value = window.innerWidth <= 900;
};

onMounted(async () => {
  await store.dispatch("fetchFunds");
  const urlParams = new URLSearchParams(window.location.search);
  const tabParam = urlParams.get("tab");
  if (["equity", "debt", "hybrid", "thematic"].includes(tabParam)) {
    activeTab.value = tabParam;
  }

  window.addEventListener("resize", handleResize);
});


watch(activeTab, (newTab) => {
  store.dispatch("fetchFunds", newTab);
});

onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
});
</script>

<style scoped>
.custom-tabs .nav-item {
  flex: 1;
  text-align: center;
  font-size: large;
}
.custom-tabs {
  display: flex;
  justify-content: space-between;
  gap: 15px;
  margin-left: -4px;
}
.custom-tabs .nav-link {
  color: #a0a0a0 !important;
  border: 1px solid #dcdcdc;
  border-radius: 10px;
  padding: 10px 20px;
  font-weight: 500;
  background: white;
  transition:
    background-color 0.3s ease,
    color 0.3s ease;
  width: 100%;
}
.custom-tabs .nav-link.active {
  background: #012e40 !important;
  color: white !important;
  border-color: #0a3d5e;
  font-weight: 600;
  border-radius: 10px;
  border: 1px solid #ffffec;
  box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.45);
}

@media (max-width: 768px) {
  .mobile-align {
    padding: 5px;
  }
}

@media (max-width: 600px) {
  .custom-tabs .nav-link {
    padding: 5px 5px !important;
    font-weight: unset !important;
  }

  .custom-tabs {
    gap: 10px !important;
  }
}

@media (min-width: 400px) and (max-width: 500px) {
  .custom-tabs {
    gap: 8px !important;
  }

  .custom-tabs .nav-link {
    font-weight: unset !important;
    padding: 4px 4px !important;
    font-size: 14px !important;
  }
}

@media (min-width: 300px) and (max-width: 400px) {
  .custom-tabs {
    gap: 6px !important;
  }

  .custom-tabs .nav-link {
    font-weight: unset !important;
    padding: 4px 4px !important;
    font-size: 10px !important;
  }
}
</style>
